// check if the current page is in an iframe
export const isInIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return false;
    }
}